const candidatureSpontaneeData = {
  title: "Le poste recherché n’est pas disponible pour le moment?",
  description:
    "Nous conserverons votre candidature pour révision future. Faire parvenir mon C.V.",
  button: "Postuler sur cet emploi",
  buttonIcon: "SVG/arrow-list.svg"
};
export default candidatureSpontaneeData;
